<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        :breadcrumbs="breadcrumbs"
        icon="mdi-format-list-checkbox"
    ></vuse-section-definition>
    <v-row>
      <v-col cols="6">
        <div class="mr-3 mx-1 rounded content_warranty" >
          <div class="ma-10" v-if="productErrorReportDetail.warranty">
            <v-row class="py-10">
            <v-col cols="12">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  :text="productErrorReportDetail.warranty.customer_fullname"
                  :value="productErrorReportDetail.warranty.customer_fullname"
                  label="Họ tên"
                  readonly
                  placeholder="Nhập họ tên"
              ></v-text-field>
            </v-col>
              <v-col cols="12">
                <v-text-field
                    background-color="#EDF2F7"
                    filled
                    :text="productErrorReportDetail.warranty.customer_phone"
                    :value="productErrorReportDetail.warranty.customer_phone"
                    readonly
                    label="Số điện thoại"
                    placeholder="Số điện thoại"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    background-color="#EDF2F7"
                    filled
                    :text="productErrorReportDetail.warranty.name_product"
                    :value="productErrorReportDetail.warranty.name_product"
                    readonly
                    label="Tên sản phẩm"
                    placeholder="Nhập tên sản phẩm"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    background-color="#EDF2F7"
                    filled
                    :text="productErrorReportDetail.warranty.seri"
                    :value="productErrorReportDetail.warranty.seri"
                    readonly
                    label="Seriel"
                    placeholder="Seriel"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    background-color="#EDF2F7"
                    filled
                    :text="productErrorReportDetail.warranty.stamp"
                    :value="productErrorReportDetail.warranty.stamp"
                    readonly
                    label="Mã tem sản phẩm"
                    placeholder="Nhập mã tem sản phẩm"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                    filled
                    :text="productErrorReportDetail.warranty.customer_address"
                    :value="productErrorReportDetail.warranty.customer_address"
                    readonly
                    label="Địa chỉ hiện tại"
                    placeholder="Nhập địa chỉ hiện tại"
                    background-color="#EDF2F7"
                >
                </v-textarea>
              </v-col>
              <v-col cols="12">
                <v-textarea
                    filled
                    :text="productErrorReportDetail.address"
                    :value="productErrorReportDetail.address"
                    readonly
                    label="Địa chỉ bảo hành"
                    placeholder="Nhập địa chỉ bảo hành"
                    background-color="#EDF2F7"
                >
                </v-textarea>
              </v-col>
              <v-col cols="12">
                <v-textarea
                    filled
                    :text="productErrorReportDetail.node"
                    :value="productErrorReportDetail.node"
                    readonly
                    label="Ghi chú khách hàng"
                    placeholder="Nhập ghi chú"
                    background-color="#EDF2F7"
                >
                </v-textarea>
              </v-col>
              <v-col cols="12">
                <v-textarea
                    filled
                    :text="productErrorReportDetail.admin_note"
                    v-model="productErrorReportDetail.admin_note"
                    label="Ghi chú quản trị viên"
                    placeholder="Nhập ghi chú"
                    background-color="#EDF2F7"
                >
                </v-textarea>
              </v-col>
              <v-col cols="6">
                <v-select
                    filled
                    class="width-input"
                    background-color="#EDF2F7"
                    v-model="productErrorReportDetail.status"
                    :items="active"
                    item-text="name"
                    item-value="id"
                    label="Chọn trạng thái kích hoạt"
                ></v-select>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>
      <v-col cols="6">
        <div class="mr-3 mx-1 rounded content_warranty" >
          <div class="ma-10">
            <v-row class="py-10">
              <v-col cols="12" v-if="list_media && list_media.length">
                <h4 class="mb-2">Hình ảnh báo lỗi</h4>
                <v-row>
                  <v-col cols="6" class="mb-1" v-for="(image, key) in list_media" :key="key">
                    <v-img
                      class="w-100"
                      :src="image.path"
                    ></v-img>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="src">
                <h4 class="mb-2">Video báo lỗi</h4>
                <v-row>
                  <v-col cols="6">
                    <video controls class="w-100">
                      <source :src="src">
                    </video>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>
      <div class="justify-center text-center my-5 border_bottom">
        <v-btn color="primary" width="180" @click="update_warranty">
          Lưu
        </v-btn>
      </div>
    </v-row>
  </div>
</template>
<script>
import {
  GET_DETAIL_PRODUCT_ERROR,
  UPDATE_PRODUCT_ERROR,
} from "@/store/modules/product_error";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      src: null,
      list_media: [],
      page: "Chi tiết",
      active: [
        {id:1, name:'CHƯA XỬ LÝ'},
        {id:2, name:'ĐÃ XỬ LÝ'},
      ],
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true
        },
        {
          text: "Bảo hành",
          disabled: true,
        },
        {
          text: "Báo lỗi sản phẩm",
          disabled: true,
        },
        {
          text: "Chi tiết",
          disabled: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      productErrorReportDetail: "productErrorReportDetail",
    }),
  },
  watch: {
    productErrorReportDetail(val){
      this.src = val.video_url;
      this.list_media = val.list_media;
    }
  },
  mounted() {
  },
  async created() {
    await this.$store.dispatch(`${GET_DETAIL_PRODUCT_ERROR}`, this.$route.params.id);
  },
  methods: {
    update_warranty() {
      let params = {
        id: this.$route.params.id,
        status:this.productErrorReportDetail.status,
        admin_note:this.productErrorReportDetail.admin_note,
      }
      this.$store.dispatch(`${UPDATE_PRODUCT_ERROR}`, params).then((data) => {
        if (data) {
          this.$toasted.success('Cập nhật thành công!', {
            duration:1000,
            position:'top-center'
          })
          this.$router.push("/manage_warranty/list_error");
        }
      });
    },
  }
};
</script>
<style scoped lang="scss">
.mw-100{
  max-width: 100%;
}
.w-100{
  width: 100%;
}
.content_warranty {
  background: #ffffff;
  min-height: 600px;
  //.v-text-field {
  //  height: 60px !important;
  //}
}
.border_bottom {
  width: 60%;
}

</style>